export const CONST_USER = 'cUser';
export const CONST_TOKEN = 'token';
export const CONST_GUEST = 'guest';
